export class SchemaTypes {
    public static readonly DocumentList = 'DocumentList';
    public static readonly ScfBuyerProspect = 'ScfBuyerProspect';
    public static readonly ArProspect = 'ArProspect';
}
